globalThis.backoffice = globalThis.backoffice || {};

backoffice.CustomerPulse = (function() {
  function customerPulse($container) {
    this.$container = $container;
  }

  customerPulse.init = function($ctx) {
    ($ctx || $('body')).find('.customer-pulse').each(function() {
      let pulse = new customerPulse($(this));
      pulse.init();
    });
  }

  customerPulse.prototype = {
    init: function() {
      this.$container.on('click', function() {
        $.post($(this).data('ajaxUrl'), function(data) {
          if(data.code) {
            new PNotify({icon: 'icon-checkmark3', title: "Pulse ajouté", type: 'success'});
          } else {
            new PNotify({icon: 'icon-cross2', title: "Pulse non ajouté", type: 'error'});
          }
        }).fail(function() {
          new PNotify({icon: 'icon-cross2', title: "Erreur serveur", type: 'error'});
        });
        return false;
      });
    }
  }

  return customerPulse;
})();
